import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";

import VoiceCallActionForm from "./VoiceCallActionForm";
import useVoiceCallActionForm from "./useVoiceCallActionForm";
import { useMemo } from "react";

export default VoiceCallAction;

function VoiceCallAction(props) {
  const { node, closePanel, assistants, onSave, validationErrors } = props;

  const voiceAssistants = assistants.filter(
    (assistant) => assistant.assistantType === "voice",
  );

  const { formState, updateFormState, errors, validate } =
    useVoiceCallActionForm(node.data, validationErrors);

  const phoneNumbers = useMemo(() => {
    if (!Boolean(formState.assistantId) || voiceAssistants.length === 0)
      return [];

    const assistant = voiceAssistants.find(
      (voiceAssistant) => voiceAssistant._id === formState.assistantId,
    );

    if (!assistant) return [];

    return assistant.communicationBinding.map((binding) => binding.identifier);
  }, [voiceAssistants, formState.assistantId]);

  const phoneNumberOptions = useMemo(() => {
    return phoneNumbers.reduce(
      (acc, phoneNumber, idx) => {
        acc.push({
          id: idx + 1,
          value: phoneNumber,
          label: phoneNumber,
        });
        return acc;
      },
      [{ id: 0, value: "", label: "No PhoneNumber Selected" }],
    );
  }, [phoneNumbers]);

  const voiceAssistantOptions = useMemo(() => {
    return voiceAssistants.reduce(
      (acc, voiceAssistant, idx) => {
        acc.push({
          id: idx + 1,
          label: voiceAssistant.name,
          value: voiceAssistant._id,
        });
        return acc;
      },
      [{ id: 0, value: "", label: "No Assistant Selected" }],
    );
  }, [voiceAssistants]);

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    const { data } = node;
    const {
      phoneNumberField,
      noAnswerRechurnEnabled,
      noAnswerRechurnAttemptsPerDay,
      noAnswerRechurnRetryIntervalMinutes,
      noAnswerRechurnTotalDays,
      noAnswerRechurnStoppingCriteriaFieldName,
      noAnswerRechurnStoppingCriteriaFieldValue,
      ...rest
    } = formState;

    const updatedData = {
      ...data,
      ...rest,
      inputMapping: {
        phoneNumberField,
      },
      noAnswerRechurn: {
        enabled: noAnswerRechurnEnabled,
        attemptsPerDay: noAnswerRechurnAttemptsPerDay,
        totalDays: noAnswerRechurnTotalDays,
        retryIntervalMinutes: noAnswerRechurnRetryIntervalMinutes,
        stoppingCriteria: {
          fieldName: noAnswerRechurnStoppingCriteriaFieldName,
          fieldValue: noAnswerRechurnStoppingCriteriaFieldValue
        }
      },
    };

    onSave(node.id, updatedData);
    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Voice Call</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <VoiceCallActionForm
          assistantOptions={voiceAssistantOptions}
          phoneNumberOptions={phoneNumberOptions}
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex items-center justify-end gap-x-2">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
